import { addVehicle } from "../../../store/slices/vehicleSlice";

export default function responseAddVehicle(response: any, api: any, arg: any) {
    console.log("Vehicle added successfully", response?.data);
    if (response?.data) {
        api.dispatch(addVehicle(response.data));
    }
    return response?.data || null;
}